export function formatDate(date: string): string {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

export function parseJmbgToDate(jmbg: string): Date | null {
  if (!jmbg || typeof jmbg !== "string") return null;
  const digits = jmbg.replace(/\D/g, "");
  if (digits.length !== 13) return null;

  const day = parseInt(digits.slice(0, 2), 10);
  const month = parseInt(digits.slice(2, 4), 10);
  const yyy = parseInt(digits.slice(4, 7), 10);

  if (!day || !month) return null;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentYearLast2 = currentYear % 100;

  // decide century:
  // - if yyy > currentYearLast2 -> assume 1000 + yyy (i.e. 1900s for typical cases like 987 -> 1987)
  // - else -> assume 2000 + (yyy as last two digits) for small yyy (001 -> 2001)
  let year: number;
  if (yyy > currentYearLast2) {
    year = 1000 + yyy;
  } else {
    // handle yyy that are already >= 100 (e.g. 987)
    year = yyy >= 100 ? 1000 + yyy : 2000 + yyy;
  }

  // validate ranges
  if (month < 1 || month > 12) return null;
  const maxDays = new Date(year, month, 0).getDate();
  if (day < 1 || day > maxDays) return null;

  return new Date(year, month - 1, day);
}

